import * as React from 'react';
import { SVGProps } from 'react';

const IconPressureStrokedSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.72 8.498a.552.552 0 0 1 .778-.778l2.9 2.373a2 2 0 0 1 2.59 2.12l1.474 1.205a.5.5 0 0 1 .036.74l-1.34 1.34a.5.5 0 0 1-.74-.037l-1.205-1.472a2 2 0 0 1-2.12-2.591l-2.373-2.9Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 12c0 4.1-2.468 7.625-6 9.168V23h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h2v-1.832A10.002 10.002 0 0 1 4 12C4 6.477 8.477 2 14 2s10 4.477 10 10Zm-10 7c4.142 0 7-2.858 7-7 0-4.142-2.858-7-7-7-4.142 0-7 2.858-7 7 0 4.142 2.858 7 7 7Z"
    />
  </svg>
);
export default IconPressureStrokedSizeL;
